import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function ColumnSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <>
      <div {...useBlockProps.save()}>
        <div className="row me-0 full-2-column">
          <div className="col-xl-6 p-0 position-relative d-flex align-items-center justify-content-center order-1">
            <img src={attributes.imageUrl} alt={attributes.imageAlt} />
          </div>
          <div className="col-xl-6 d-flex align-items-center order-2 overflow-hidden">
            <div className="container h-100 overflow-right ms-5">
              <div className="text-swiper position-relative">
                <div className="swiper-wrapper">
                  <InnerBlocks.Content />
                </div>
                <div className="swiper-scrollbar"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
